import "./navbar.scss";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";

export const Navbar = () => {
  return (
    <div className="navbar">
      <div className="options">
        <a href="#home" title="Home">
          <HomeOutlinedIcon className="icon"/>
        </a>
        <a href="#about" title="About">
          <PersonOutlineOutlinedIcon className="icon"/>
        </a>
        <a href="#projects" title="Projects">
          <WorkOutlineOutlinedIcon className="icon"/>
        </a>
        <a href="#contact" title="Contact">
          <PostAddOutlinedIcon className="icon"/>
        </a>
      </div>
    </div>
  );
};
